/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Offerdetail_Achievements_Lastupdatedtooltip3Inputs */

const id_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set pencapaian ini terakhir diperbarui pada ${i?.date}.`)
};

const ms_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set pencapaian ini terakhir dikemas kini pada ${i?.date}.`)
};

const da_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dette achievement-sæt blev sidst opdateret den ${i?.date}.`)
};

const de_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Errungenschaften-Set wurde zuletzt am ${i?.date} aktualisiert.`)
};

const en_us2_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This achievement set was last updated on ${i?.date}.`)
};

const es_es2_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este conjunto de logros se actualizó por última vez el ${i?.date}.`)
};

const es_mx2_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este conjunto de logros se actualizó por última vez el ${i?.date}.`)
};

const fil_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ang achievement set na ito ay huling na-update noong ${i?.date}.`)
};

const fr_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cet ensemble de succès a été mis à jour pour la dernière fois le ${i?.date}.`)
};

const it_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questo set di risultati è stato aggiornato l'${i?.date}.`)
};

const hu_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ez a teljesítménykészlet utoljára ${i?.date}-án frissült.`)
};

const nl_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deze prestatieset is voor het laatst bijgewerkt op ${i?.date}.`)
};

const no_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dette prestasjonssettet ble sist oppdatert ${i?.date}.`)
};

const pl_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ten zestaw osiągnięć został ostatnio zaktualizowany ${i?.date}.`)
};

const pt_br2_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este conjunto de conquistas foi atualizado pela última vez em ${i?.date}.`)
};

const pt_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este conjunto de conquistas foi atualizado pela última vez em ${i?.date}.`)
};

const ro_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Acest set de realizări a fost actualizat ultima dată pe ${i?.date}.`)
};

const fi_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tämä saavutussarja päivitettiin viimeksi ${i?.date}.`)
};

const sv_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Denna prestationsuppsättning uppdaterades senast ${i?.date}.`)
};

const vi_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bộ thành tích này được cập nhật lần cuối vào ${i?.date}.`)
};

const tr_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bu başarım seti en son ${i?.date} tarihinde güncellendi.`)
};

const cs_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tato sada úspěchů byla naposledy aktualizována ${i?.date}.`)
};

const bg_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Този набор от постижения е актуализиран последно на ${i?.date}.`)
};

const ru_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Этот набор достижений последний раз обновлялся ${i?.date}.`)
};

const uk_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Цей набір досягнень востаннє оновлено ${i?.date}.`)
};

const ar_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`آخر تحديث لمجموعة الإنجازات هذه كان في ${i?.date}.`)
};

const hi_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`यह उपलब्धि सेट अंतिम बार ${i?.date} को अपडेट किया गया था।`)
};

const th_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ชุดความสำเร็จนี้ได้รับการอัปเดตล่าสุดเมื่อ ${i?.date}`)
};

const ja_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この実績セットの最終更新日は ${i?.date} です。`)
};

const zh_cn2_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`此成就集合最后更新于 ${i?.date}。`)
};

const zh_hant1_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`此成就集合最後更新於 ${i?.date}。`)
};

const ko_offerdetail_achievements_lastupdatedtooltip3 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`이 도전 과제 세트는 ${i?.date}에 마지막으로 업데이트되었습니다.`)
};

/**
* | output |
* | --- |
* | "This achievement set was last updated on {date}." |
*
* @param {Offerdetail_Achievements_Lastupdatedtooltip3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_lastupdatedtooltip3 = /** @type {((inputs: Offerdetail_Achievements_Lastupdatedtooltip3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Lastupdatedtooltip3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "da") return da_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "de") return de_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "it") return it_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "no") return no_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "th") return th_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_lastupdatedtooltip3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_lastupdatedtooltip3(inputs)
	return ko_offerdetail_achievements_lastupdatedtooltip3(inputs)
});
export { offerdetail_achievements_lastupdatedtooltip3 as "offerDetail.achievements.lastUpdatedTooltip" }